<template>
    <v-container fluid>
        <v-layout wrap>
            <v-col cols="12">
                Welcome to the Wyoming Department of Environmental Quality's Spill and Complaint website.
                <p />
                To report a spill or complaint, please click on the links provided in the menu. Also, the public can view and download past spill and complaints on this page.
                <p />
                <a href="https://deqspills.wyo.gov">DEQSpills.wyo.gov</a> will allow all residents to use geographic information systems (GIS) to map and locate spills or incidents across the state. In particular, when using a mobile device, residents will be able to use their phones’ GPS to pinpoint the exact latitude and longitude of a spill or incident. The site works on desktop computers, as well, but without the GPS capabilities.
            </v-col>
        </v-layout>
        <v-layout wrap mt-5>
            <v-col cols="12">
                <spillComplaintsReport :hideHeader="true" />
            </v-col>
        </v-layout>
    </v-container>
</template>

<script>
import spillComplaintsReport from '@/components/SpillComplaintsReport.vue'

export default {
    components: {
        spillComplaintsReport
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
    }
}
</script>
